import './info-blocks.scss';
import Swiper from 'swiper';
import 'swiper/css';

document.addEventListener( 'DOMContentLoaded', function() {

	const sliders = document.querySelectorAll( '.js-infoBlocksSlider' );

	sliders.forEach( function( slider ) {
		const slideCount = slider.querySelectorAll( '.swiper-slide' ).length;
		
		const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
		
		const allowDragging = isMobile ? slideCount >= 2 : slideCount >= 3;

		new Swiper( slider, {
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				667: {
					spaceBetween: 32
				}
			},
			grabCursor: allowDragging,
			allowTouchMove: allowDragging
		} );
	} );

} );